export default __webpack_public_path__ + "static/media/configuration-12.0cc46afa.svg";